<template>
  <v-container fill-height fluid pa-0>
    <v-layout row justify-center align-center fill-height>
      <v-flex xs12 sm8 class="text-xs-center">
        <img src="@/assets/login.svg" style="width: 80%;" />
      </v-flex>
      <v-flex xs12 sm4 fill-height class="text-xs-center white d-flex align-center">
        <v-card flat class="px-3">
          <div>
            <img src="@/assets/logo.png" />
          </div>
          <div class="headline text-xs-center mb-5">Zaitoon Hospital</div>
          <v-card-text class="pa-0">
            <v-alert class="mb-3" outline type="error" :value="!!error">{{error}}</v-alert>

            <v-form v-model="valid" ref="form" lazy-validation>
              <v-container grid-list-md fluid>
                <v-layout column>
                  <v-flex>
                    <v-text-field
                      single-line
                      label="Email"
                      v-model="email"
                      :rules="[requiredRule,emailRule]"
                      required
                      type="email"
                      validate-on-blur
                      name="email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      single-line
                      :rules="[requiredRule, passwordRule]"
                      label="Password"
                      min="6"
                      :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (e1 = !e1)"
                      :type="e1 ? 'password' : 'text'"
                      v-model="password"
                      @keyup.enter="submit"
                      validate-on-blur
                      name="password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn
                      :loading="loading"
                      class="mx-0"
                      color="primary"
                      @click="submit"
                      :disabled="!valid"
                    >Login</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  layout: "auth",
  middleware: "guest",
  metaInfo: {
    title: "Login"
  },
  data() {
    return {
      valid: true,
      email: "",
      password: "",
      e1: true,
      loading: false,

      requiredRule: v => !!v || "This field is required.",
      passwordRule: v => !(v.length < 6) || "Greater than 6 characters.",
      emailRule: v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Email must be valid."
    };
  },
  computed: {
    error() {
      return this.$store.getters["auth/error"];
    }
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate) {
        this.loading = true;

        const client = {
          grant_type: "password",
          client_id: "2",
          client_secret: "YzJhPuS0gwyjPUON7IMo4wB6nRL3it00cQO1sOiv",
          scope: ""
        };

        await this.$store.dispatch("auth/login", {
          password: this.password,
          username: this.email,
          ...client
        });

        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.parent-container {
  height: 100%;
}
</style>